(function () {
    'use strict';

    angular
        .module('app')
        .controller('CheckoutController', CheckoutController);

    CheckoutController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies', 'dialog', 'eventTracker', 'authenticator', 'countries'];

    function CheckoutController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies, dialog, eventTracker, authenticator, countries) {
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.back = back;
        vm.pay = pay;
        vm.lowFiBookingFeeInfo = lowFiBookingFeeInfo;
        vm.hasUserInfo = hasUserInfo;
        vm.countries = countries;
        vm.checkEmail = checkEmail;
        vm.goToLogin = goToLogin;
        vm.continuePurchase = continuePurchase;

        function init() {
            vm.payment_loading = true;
            vm.checkoutItems = [];
            vm.user = {};
            authenticator.checkLoginStatus().then(function(response) {
                vm.isLoggedIn = response;
            })
            vm.isLight = authenticator.isLight();
            getStripePK()
                .then(function (response) {
                    getUser()
                        .then(function (response) {
                            setupStripe();
                        });
                    getCheckout().then(function () {
                        vm.payment_loading = false;
                    });
                });
        }

        $scope.$on('$destroy', function () {
            if (vm.payment_status != 'completed') {
                $http.post('api/checkout/failed_checkout/', JSON.stringify({
                    checkout_id: $stateParams.checkout_id
                }));
            }
        });

        function getStripePK() {
            return $http.get('api/stripe_pk/')
                .then(function (response) {
                    vm.stripe_pk = response.data;
                });
        }

        function setupStripe() {
            angular.element(function () {
                vm.stripe = Stripe(vm.stripe_pk);
                vm.elements = vm.stripe.elements();
                var style = {
                    base: {
                        color: '#321e4c',
                        fontSize: '18px',
                        letterSpacing: '0.2px'
                    },

                    invalid: {
                        color: '#F10B02'
                    },
                    complete: {
                        color: '#321e4c'
                    }

                };
                var lang = $cookies.get('selected_language');
                var cardExpiryPlaceholder = "MM / YY";
                if (lang == 'da_dk') {
                    cardExpiryPlaceholder = "MM / ÅÅ"
                }
                vm.cardNumber = vm.elements.create('cardNumber', { style: style, placeholder: '' });
                vm.cardExpiry = vm.elements.create('cardExpiry', { style: style, placeholder: cardExpiryPlaceholder });
                vm.cardCvc = vm.elements.create('cardCvc', { style: style });
                vm.cardNumber.mount('#card-number');
                vm.cardExpiry.mount('#card-expiry');
                vm.cardCvc.mount('#card-cvc');
                vm.cardNumber.on('change', function (event) {
                    vm.cardNumber_is_complete = event.complete;
                    $scope.$apply();
                });
                vm.cardExpiry.on('change', function (event) {
                    vm.cardExpiry_is_complete = event.complete;
                    $scope.$apply();

                });
                vm.cardCvc.on('change', function (event) {
                    vm.cardCvc_is_complete = event.complete;
                    $scope.$apply();
                });
            });
        }

        function getCheckout() {
            return $http.post('/app/api/checkout/get/', { checkout_id: parseInt($stateParams.checkout_id) })
                .then(function (response) {
                    vm.checkout = response.data;
                    if(vm.checkout.checkout_total == 0) {
                        vm.voucherOrGiftCardPayed = true;
                    }
                    if (vm.checkout.checkout_type === 'tickets') {
                        vm.checkoutCompleteState = 'ticket_checkout_complete';
                        vm.checkoutCloseState = 'concert';
                        vm.checkoutCloseParams = {concert_slug: vm.checkout.items[0].concert_slug};
                        if ($stateParams.concert && $stateParams.ticket_amount) {
                            eventTracker.checkout($stateParams.concert, $stateParams.ticket_amount);
                        }
                    }
                    if (vm.checkout.checkout_type === 'gift_card') {
                        vm.checkoutCompleteState = 'gift_card_checkout_complete';
                        vm.checkoutCloseState = 'gift_card_guide';
                        vm.checkoutCloseParams = {};
                    }
                    if (vm.checkout.checkout_type === 'band_booking') {
                        vm.checkoutCompleteState = 'booking_checkout_complete';
                        vm.checkoutCloseState = 'musician';
                        getBookingDetails(vm.checkout.items[0].band_booking_token).then(function () {
                            vm.checkoutCloseParams = {band_slug: vm.booking.band_slug};
                        });
                    }
                });
        }

        function continuePurchase() {
            return lightLogin().then(function() {
                var data = {
                    payment_method_id: null,
                    checkout_id: vm.checkout.checkout_id
                }
                $http.post('api/checkout/pay/', data).then(function (response) {
                    vm.checkout_loading = false;
                    eventTracker.addToCart($stateParams.concert, $stateParams.source_page, $stateParams.ticket_amount);
                    $state.go('ticket_checkout_complete', { 
                        checkout_id: $stateParams.checkout_id,
                        concert: $stateParams.concert,
                        ticket_amount: $stateParams.ticket_amount
                    });
                });
            });
        }

        function goToLogin() {
            var backState = angular.copy($stateParams);
            if(vm.user.user_email) {
                return $state.go('login_return', {'user_email': vm.user.user_email, 'backToStateName': 'checkout', 'backToStateParams': backState });
            } else {
                return $state.go('login', {'backToStateName': 'checkout', 'backToStateParams': backState });
            }
        }

        function checkEmail() {
            $http.get('api/users/check_email/' + vm.user.user_email.replace('+', '%2B')).then(function(response){
                if(response.data.email_already_exists && !response.data.is_light) {
                    vm.showLoginOption = true;
                } else {
                    vm.showLoginOption = false;
                }
            });
        }

        function lightLogin() {
            if(vm.logged_in) {
                return new Promise(function(resolve, reject) {resolve();});
            } else {
                 return $http.get('api/users/check_email/' + vm.user.user_email.replace('+', '%2B')).then(function(response){
                    return $http.post('api/users/light/', {
                        email: vm.user.user_email, 
                        user_firstname: vm.user.user_firstname,
                        user_lastname: vm.user.user_lastname,
                        user_country: vm.user.user_country,
                        user_postcode: vm.user.user_postcode,
                    }).then(function(response){
                        return authenticator.loginLight(vm.user.user_email).then(function(response){
                        });
                    });
                });
            }
        }

        function pay() {
            vm.payment_loading = true;
            vm.error_details = '';
            return lightLogin().then(function() {
                return getStripeToken()
                .then(function (result) {
                    if (result.paymentMethod) {
                        var data = {
                            payment_method_id: result.paymentMethod.id,
                            checkout_id: $stateParams.checkout_id
                        };
                        return $http.post('api/checkout/pay/', data)
                            .then(handle_server_response)
                            .catch(function (result) {
                                change_transaction_status('failed');
                                vm.payment_loading = false;
                                vm.error_details = result.data.error.message;
                                vm.error_code = result.data.error.code;
                                vm.decline_code = result.data.error.decline_code;
                                vm.show_error = true;
                                return result;
                            });
                    } else {
                        change_transaction_status('failed');
                        vm.payment_loading = false;
                        vm.error_details = result.error.message;
                        vm.error_code = result.error.code;
                        vm.decline_code = result.error.decline_code;
                        vm.show_error = true;
                        $scope.$applyAsync();
                        return result;
                    }

                })
                .catch(function (result) {
                    change_transaction_status('failed');
                    vm.payment_loading = false;
                    vm.error_details = result.error.message;
                    vm.error_code = result.error.code;
                    vm.decline_code = result.error.decline_code;
                    vm.show_error = true;
                    $scope.$applyAsync();
                    return result;

                });
            });
        }


        function handle_server_response(response) {
            if (response.data.error) {
                change_transaction_status('failed');
                vm.payment_loading = false;
                vm.error_details = response.data.error.message;
                vm.error_code = response.data.error.code;
                vm.decline_code = response.data.error.decline_code;
                vm.show_error = true;
            } else if (response.data.requires_action) {
                handle_stripe_requirering_action(response.data);
            } else {
                change_transaction_status('completed');
                vm.payment_loading = false;

                if(vm.checkoutCompleteState == "ticket_checkout_complete"){
                    $state.go(vm.checkoutCompleteState, {
                        checkout_id: $stateParams.checkout_id,
                        concert: $stateParams.concert,
                        ticket_amount: $stateParams.ticket_amount
                    });
                } else {
                    $state.go(vm.checkoutCompleteState, {
                        checkout_id: $stateParams.checkout_id
                    });
                }
                return response.data;
            }
        }

        function handle_stripe_requirering_action(response) {
            vm.stripe.handleCardAction(
                response.payment_intent_client_secret
            ).then(function (result) {
                if (result.error) {
                    change_transaction_status('failed');
                    vm.payment_loading = false;
                    vm.error_details = result.error.message;
                    vm.error_code = result.error.code;
                    vm.decline_code = result.error.decline_code;
                    vm.show_error = true;
                    $scope.$applyAsync();
                    return result;
                } else {
                    return $http.post('api/checkout/required_action/', JSON.stringify({
                        payment_intent_id: result.paymentIntent.id,
                        checkout_id: $stateParams.checkout_id
                    }))
                        .then(handle_server_response)
                        .catch(function (response) {
                            change_transaction_status('failed');
                            vm.payment_loading = false;
                            vm.error_details = response.data.error.message;
                            vm.error_code = response.data.error.code;
                            vm.decline_code = response.data.error.decline_code;
                            vm.show_error = true;
                            return response;
                        });
                }
            });
        }

        function change_transaction_status(payment_status) {
            vm.payment_status = payment_status;
            vm.payment_loading = true;
        }

        function getStripeToken() {
            return vm.stripe.createPaymentMethod('card', vm.cardNumber, {
                billing_details: {
                    name: vm.payment.cardholder_name,
                },
            });
        }

        function getUser() {
            return authenticator.checkLoginStatus()
                .then(function (loggedIn) {
                    vm.logged_in = loggedIn;
                    if(vm.logged_in) {
                        return $http.get('/app/api/private/users/')
                        .then(function (response) {
                            vm.user = response.data;
                            if(vm.user.is_light) {
                                vm.user.user_firstname = '';
                                vm.user.user_lastname = ''
                                vm.user.user_postcode = '';
                            }
                        });
                    } else {
                        return new Promise(function(resolve, reject) {
                            vm.user = {}
                            vm.user.user_country = "DK";
                            resolve();
                        });
                    }
                });


            /*  */
        }
        function hasUserInfo() {
            return vm.isLoggedIn || (!vm.isLoggedIn && vm.user.user_email != '' && vm.user.user_email == vm.confirm_email && vm.user.user_firstname != '' && vm.user.user_lastname != '' && vm.user.user_postcode != '');
        }

        function getBookingDetails(booking_token) {
            return $http.get('api/booking/band/' + booking_token)
                .then(function (response) {
                    vm.booking = response.data;

                    vm.booking.band_booking_time = moment(vm.booking.band_booking_time, "hh:mm:ss").toDate();
                    vm.booking.band_booking_date = moment(vm.booking.band_booking_date).toDate();

                    vm.booking.band_booking_low_fi_share = Math.round(vm.booking.band_booking_fee * vm.booking.band_booking_lowfi_percentage)/100;
                    vm.booking.band_booking_musician_share = Math.round(vm.booking.band_booking_fee * vm.booking.band_booking_band_percentage)/100;

                    if (vm.booking.band_booking_paid_timestamp != null) {
                        alert("This booking has already been paid.");
                        close();
                    }
                });
        }

        function lowFiBookingFeeInfo() {
            dialog.info('low-fi-booking-fee-info');
        }

        function close() {
            $state.go(vm.checkoutCloseState, vm.checkoutCloseParams);

        }

        function back() {
            if(vm.checkout.checkout_type === 'band_booking') {
                window.history.go(-2);
            } else {
                window.history.back()
            }
        }

    }
})();
